import React from 'react';
import {Route, Switch} from 'react-router-dom';
import RouterSuspense from '~/app/common/RouterSuspense';
import List from './';
import ProjectDetail from './Detail';

export const PROJECTS_ROUTES = {
    projects: '/',
    list: '/projects',
    detail: '/project-chat/:projectId',
};

export type RouterComponent = React.FC

const Router: RouterComponent = () => (
    <RouterSuspense>
        <Switch>
            <Route exact path={PROJECTS_ROUTES.detail} component={ProjectDetail} />
            <Route path={[PROJECTS_ROUTES.projects, PROJECTS_ROUTES.list]} component={List} />
        </Switch>
    </RouterSuspense>
);

export default Router;